import { ContentText } from "components/atoms/Text";

const LinkedInCard = ({ title, description, images }) => {
    return (
        <div className="w-[481px] rounded-lg phone:w-full tablet:w-[386px] phone:p-6 p-10 tablet:p-8 tablet:pr-[30px] desktop:pr-[48px] shadow-linkedinProxyCard bg-neutral-10">
            <h2 className="font-semibold text-neutral-100 text-[32px] tablet:text-heading-4 phone:text-heading-4">{title}</h2>
            <ContentText classNames="mt-3 desktop:pr-[30px] !tracking-[0px]">{description}</ContentText>
            <div className="w-full p-[37px] bg-neutral-20 phone:h-[229px] h-[310px] flex items-center justify-center tablet:h-[250px] rounded-lg desktop:h-[310px] mt-8 tablet:mt-8 phone:mt-6">
                <img src={`/images/proxy/linkedin/${images}.svg`} className="w-full" />
            </div>
        </div>
    );
};

export default LinkedInCard;